module.exports = __webpack_public_path__ + "img/camion.609480d9.png";